import { render, staticRenderFns } from "./ProductCardsSlider.vue?vue&type=template&id=2e65f506&"
import script from "./ProductCardsSlider.vue?vue&type=script&lang=js&"
export * from "./ProductCardsSlider.vue?vue&type=script&lang=js&"
import style0 from "./ProductCardsSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports